import { useState, useEffect } from "react";
import {  Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import AntdTable from "../../../antd/Table/Table";
import { useGetDeviceAssignmentHistoryQuery } from "../../../../Redux/service/Permissions/CustomerPermissions";
import trans from "../../../../utils";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";

const AssignmentHistoryPopup = ({ deviceId, deviceName, onClose }) => {
  const [params, setParams] = useState({
    deviceId: deviceId,
    page: 1,
    limit: 10,
    search: "",
    status: "",
    sortBy: "",
    sortOrder: "",
  });

  const [searchValue, setSearchValue] = useState("");
  const [statusValue, setStatusValue] = useState("");

  const { data: apiResponse, isLoading } = useGetDeviceAssignmentHistoryQuery(
    params,
    {
      skip: !deviceId,
    }
  );

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setParams((prev) => ({ ...prev, search: searchValue, page: 1 }));
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue]);

  const handlePageChange = (page) => {
    setParams((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setParams((prev) => ({ ...prev, limit, page: 1 }));
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setParams((prev) => ({
        ...prev,
        sortBy: sorter.field,
        sortOrder: sorter.order === "ascend" ? "asc" : "desc",
      }));
    } else {
      setParams((prev) => ({
        ...prev,
        sortBy: "",
        sortOrder: "",
      }));
    }
  };

  const handleStatusChange = (value) => {
    setStatusValue(value);
    setParams((prev) => ({ ...prev, status: value, page: 1 }));
  };

  const columns = [
    {
      title: trans("User Name"),
      dataIndex: "user_name",
      key: "user_name",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Department"),
      dataIndex: "technician_details",
      key: "department",
      width: 150,
      sorter: true,
      render: (value) => value?.department || "- - - - -",
    },
    {
      title: trans("Assigned At"),
      dataIndex: "assigned_at",
      key: "assigned_at",
      width: 180,
      sorter: true,
      render: (date) =>
        date ? dayjs(date).format("DD/MM/YYYY HH:mm") : "- - - - -",
    },
    {
      title: trans("Unassigned At"),
      dataIndex: "unassigned_at",
      key: "unassigned_at",
      width: 180,
      sorter: true,
      render: (date) =>
        date ? dayjs(date).format("DD/MM/YYYY HH:mm") : "- - - - -",
    },
    {
      title: trans("Duration Days"),
      dataIndex: "duration_days",
      key: "duration_days",
      width: 120,
      sorter: true,
    },
    {
      title: trans("Assignment Reason"),
      dataIndex: "assignment_reason",
      key: "assignment_reason",
      width: 200,
      sorter: true,
    },
  ];

  const extractedData = apiResponse?.assignment_history || [];
  const totalItems = apiResponse?.pagination?.total_items || 0;

  console.log(extractedData);
  return (
    <Popup show={!!deviceId} size="xl">
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={`${trans("Assignment History")} - ${deviceName || ""}`}
            nospace={true}
          />
        </Modal.Title>
        <Close style="close-32 close" close={onClose} img="Close" />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        {/* Filters Section */}
        <div className="mb-3 d-flex gap-3 align-items-center">
          <Input
            placeholder={trans("Search")}
            prefix={<SearchOutlined />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{ width: 350 }}
            allowClear
          />
          {/* <Select
            placeholder={trans("Filter by Status")}
            value={statusValue || undefined}
            onChange={handleStatusChange}
            style={{ width: 200 }}
            allowClear
            options={[
              { value: "", label: trans("All") },
              { value: "active", label: trans("Active") },
              { value: "inactive", label: trans("Inactive") },
            ]}
          /> */}
        </div>

        {/* Table */}
        <AntdTable
          columns={columns}
          dataSource={extractedData}
          loading={isLoading}
          pageSize={params.limit}
          totalItems={totalItems}
          currentPage={params.page}
          onPageChange={handlePageChange}
          onLimitChange={handleLimitChange}
          onTableChange={handleTableChange}
          scrollY={400}
          scrollX={true}
        />
      </Modal.Body>
    </Popup>
  );
};

export default AssignmentHistoryPopup;

